import { render, staticRenderFns } from "./UISlider.vue?vue&type=template&id=203afc2a"
import script from "./UISlider.vue?vue&type=script&lang=js"
export * from "./UISlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports